<template>
  <div>
    <head>
      <meta charset="utf-8" />
      <title>Update Requests Management</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <meta content="Property Update Requests Management" name="description" />
      <meta content="County Revenue System" name="author" />
      <!-- App favicon -->
      <link rel="shortcut icon" href="assets/images/favicon.png">

      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
    </head>

    <body @contextmenu.prevent data-sidebar="dark">
    <NavigationBar/>
    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">

          <!-- tool bar -->
          <ToolBarValuation/>
          <!-- end of toolbar -->

          <!-- Page Title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Update Requests Management</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);" @click="gotTo('dashboard')">Dashboard</a></li>
                    <li class="breadcrumb-item"><a href="javascript: void(0);" @click="gotTo('valuation-dashboard')">Valuation Roll</a></li>
                    <li class="breadcrumb-item active">Update Requests</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Summary Cards -->
          <div class="row mb-4">
            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Total Requests</p>
                      <h4 class="mb-0">{{totalRequests.toLocaleString()}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-primary">
                          <span class="avatar-title">
                            <i class="bx bx-file font-size-24"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Pending Approval</p>
                      <h4 class="mb-0">{{pendingRequests.toLocaleString()}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-warning">
                          <span class="avatar-title">
                            <i class="bx bx-time-five font-size-24"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Approved Today</p>
                      <h4 class="mb-0">{{approvedToday.toLocaleString()}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-success">
                          <span class="avatar-title">
                            <i class="bx bx-check-circle font-size-24"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Avg Processing Time</p>
                      <h4 class="mb-0">{{averageProcessingTime}} days</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-info">
                          <span class="avatar-title">
                            <i class="bx bx-timer font-size-24"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Main Requests Table -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white">
                  <div class="row align-items-center">
                    <div class="col-md-6">
                      <h4 class="card-title mb-0">Property Update Requests</h4>
                      <p class="text-muted mb-0 mt-1">
                        <i class="bx bx-edit me-1"></i>
                        Showing {{updateRequests.length}} of {{totalRequests}} requests
                      </p>
                    </div>
                    <div class="col-md-6 text-md-end">
                      <button @click="refreshData" class="btn btn-sm btn-outline-primary me-2" :disabled="loading">
                        <i class="bx bx-refresh" :class="{'bx-spin': loading}"></i> Refresh
                      </button>
                      <div class="btn-group me-2" role="group">
                        <button @click="setStatusFilter('pending')" class="btn btn-sm" :class="statusFilter === 'pending' ? 'btn-warning' : 'btn-outline-warning'">Pending</button>
                        <button @click="setStatusFilter('under_review')" class="btn btn-sm" :class="statusFilter === 'under_review' ? 'btn-info' : 'btn-outline-info'">Under Review</button>
                        <button @click="setStatusFilter('approved')" class="btn btn-sm" :class="statusFilter === 'approved' ? 'btn-success' : 'btn-outline-success'">Approved</button>
                        <button @click="setStatusFilter('rejected')" class="btn btn-sm" :class="statusFilter === 'rejected' ? 'btn-danger' : 'btn-outline-danger'">Rejected</button>
                        <button @click="setStatusFilter('')" class="btn btn-sm" :class="statusFilter === '' ? 'btn-primary' : 'btn-outline-primary'">All</button>
                      </div>
                      <button v-if="getRight('DOWNLOAD REPORTS')" @click="downloadReport" class="btn btn-sm btn-primary">
                        <i class="bx bx-download"></i> Export
                      </button>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <!-- Search and Filter Row -->
                  <div class="row mb-4">
                    <div class="col-md-4">
                      <label class="form-label">Search Requests</label>
                      <div class="input-group">
                        <input
                            v-model="searchTerm"
                            class="form-control"
                            type="text"
                            placeholder="Reference Number, LR Number, Owner Name"
                            @keyup.enter="searchRequests"
                        >
                        <button @click="searchRequests" class="btn btn-primary">
                          <i class="bx bx-search"></i>
                        </button>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <label class="form-label">Date From</label>
                      <input v-model="dateFrom" class="form-control" type="date" @change="applyFilters">
                    </div>
                    <div class="col-md-2">
                      <label class="form-label">Date To</label>
                      <input v-model="dateTo" class="form-control" type="date" @change="applyFilters">
                    </div>
                    <div class="col-md-2">
                      <label class="form-label">Update Type</label>
                      <select v-model="updateTypeFilter" @change="applyFilters" class="form-control">
                        <option value="">All Types</option>
                        <option value="Owner Information">Owner Information</option>
                        <option value="Property Details">Property Details</option>
                        <option value="Ownership Transfer">Ownership Transfer</option>
                        <option value="Property Improvements">Property Improvements</option>
                      </select>
                    </div>
                    <div class="col-md-2">
                      <label class="form-label">&nbsp;</label>
                      <button @click="clearFilters" class="btn btn-outline-secondary w-100">
                        <i class="bx bx-x"></i> Clear Filters
                      </button>
                    </div>
                  </div>

                  <!-- Requests Table -->
                  <div class="table-responsive">
                    <table class="table table-hover align-middle mb-0" v-if="!loading && updateRequests.length > 0">
                      <thead class="table-dark">
                      <tr>
                        <th style="width: 5%">#</th>
                        <th style="width: 15%">Reference Number</th>
                        <th style="width: 15%">LR Number</th>
                        <th style="width: 20%">Owner Name</th>
                        <th style="width: 15%">Update Type</th>
                        <th style="width: 10%">Status</th>
                        <th style="width: 10%">Submitted</th>
                        <th style="width: 10%">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(request, index) in paginatedRequests" :key="request.id">
                        <td>{{(currentPage - 1) * perPage + index + 1}}</td>
                        <td>
                          <div class="d-flex align-items-center">
                            <div class="avatar-xs me-2">
                                  <span class="avatar-title rounded-circle" :class="getStatusIcon(request.status)">
                                    <i :class="getRequestIcon(request.status)"></i>
                                  </span>
                            </div>
                            <div>
                              <h6 class="mb-0 text-primary">{{request.referenceNumber}}</h6>
                              <small class="text-muted">{{formatDate(request.submitted_date)}}</small>
                            </div>
                          </div>
                        </td>
                        <td>
                          <strong>{{request.LRNumber}}</strong>
                        </td>
                        <td>
                          <h6 class="mb-0">{{request.ownerNames}}</h6>
                          <small class="text-muted">{{request.requesterPhone || 'No phone'}}</small>
                        </td>
                        <td>
                          <span class="badge bg-soft-info text-info">{{request.update_type}}</span>
                        </td>
                        <td>
                          <span class="badge" :class="getStatusBadge(request.status)">
                            {{request.status.toUpperCase()}}
                          </span>
                        </td>
                        <td>
                          <span>{{formatDate(request.submitted_date)}}</span><br>
                          <small class="text-muted">{{getTimeAgo(request.submitted_date)}}</small>
                        </td>
                        <td>
                          <div class="dropdown">
                            <button class="btn btn-sm btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown">
                              <i class="bx bx-dots-vertical-rounded"></i>
                            </button>
                            <ul class="dropdown-menu">
                              <li><a class="dropdown-item" @click="showRequestDetails(request)"><i class="bx bx-eye me-2"></i>View Details</a></li>
                              <li><a class="dropdown-item" @click="showDocuments(request)"><i class="bx bx-file me-2"></i>View Documents</a></li>
                              <li><a class="dropdown-item" @click="showWorkflowHistory(request)"><i class="bx bx-history me-2"></i>View History</a></li>
                              <li><hr class="dropdown-divider"></li>
                              <li v-if="request.status === 'pending'" class="dropdown-submenu">
                                <a class="dropdown-item" @click="approveRequest(request)"><i class="bx bx-check me-2 text-success"></i>Approve</a>
                              </li>
                              <li v-if="request.status === 'pending'" class="dropdown-submenu">
                                <a class="dropdown-item" @click="rejectRequest(request)"><i class="bx bx-x me-2 text-danger"></i>Reject</a>
                              </li>
                              <li v-if="request.status === 'pending'">
                                <a class="dropdown-item" @click="requestMoreInfo(request)"><i class="bx bx-info-circle me-2 text-warning"></i>Request More Info</a>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>

                    <!-- Loading State -->
                    <div v-if="loading" class="text-center py-5">
                      <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                      <p class="mt-3 mb-0">Loading update requests...</p>
                    </div>

                    <!-- Empty State -->
                    <div v-if="!loading && updateRequests.length === 0" class="text-center py-5">
                      <img :src="'./assets/images/no-results.png'" alt="No results" style="width: 150px; opacity: 0.5;">
                      <h5 class="mt-3">No Update Requests Found</h5>
                      <p class="text-muted">No update requests match your search criteria.</p>
                      <button @click="clearFilters" class="btn btn-primary">Clear Filters</button>
                    </div>
                  </div>

                  <!-- Pagination -->
                  <div class="row mt-4" v-if="!loading && updateRequests.length > 0">
                    <div class="col-md-6">
                      <p class="text-muted">
                        Showing {{(currentPage - 1) * perPage + 1}} to {{Math.min(currentPage * perPage, totalRequests)}} of {{totalRequests}} requests
                      </p>
                    </div>
                    <div class="col-md-6">
                      <nav>
                        <ul class="pagination justify-content-end mb-0">
                          <li class="page-item" :class="{disabled: currentPage === 1}">
                            <a class="page-link" @click="changePage(currentPage - 1)" href="javascript:void(0)">Previous</a>
                          </li>
                          <li
                              v-for="page in visiblePages"
                              :key="page"
                              class="page-item"
                              :class="{active: page === currentPage}"
                          >
                            <a class="page-link" @click="changePage(page)" href="javascript:void(0)">{{page}}</a>
                          </li>
                          <li class="page-item" :class="{disabled: currentPage === totalPages}">
                            <a class="page-link" @click="changePage(currentPage + 1)" href="javascript:void(0)">Next</a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <!-- Approval Modal -->
          <div v-if="showApprovalModal" class="modal show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5);">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header text-white">
                  <h5 class="modal-title">
                    <i class="bx bx-check-circle me-2"></i>
                    Approve Update Request
                  </h5>
                  <button type="button" class="btn-close btn-close-white" @click="closeApprovalModal"></button>
                </div>
                <div class="modal-body">
                  <div v-if="selectedRequest">
                    <div class="row mb-3">
                      <div class="col-md-6">
                        <strong>Reference Number:</strong> {{selectedRequest.referenceNumber}}
                      </div>
                      <div class="col-md-6">
                        <strong>LR Number:</strong> {{selectedRequest.LRNumber}}
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-md-6">
                        <strong>Owner:</strong> {{selectedRequest.ownerNames}}
                      </div>
                      <div class="col-md-6">
                        <strong>Update Type:</strong> {{selectedRequest.update_type}}
                      </div>
                    </div>

                    <div class="form-group mb-3">
                      <label class="form-label">Approval Notes (Optional)</label>
                      <textarea
                          v-model="approvalNotes"
                          class="form-control"
                          rows="3"
                          placeholder="Add any notes regarding this approval..."
                      ></textarea>
                    </div>

                    <div class="alert alert-info">
                      <i class="bx bx-info-circle me-2"></i>
                      <strong>Note:</strong> Approving this request will update the property records immediately. This action cannot be undone.
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" @click="closeApprovalModal">Cancel</button>
                  <button type="button" class="btn btn-success" @click="confirmApproval" :disabled="processing">
                    <span v-if="processing" class="spinner-border spinner-border-sm me-2"></span>
                    <i v-else class="bx bx-check me-2"></i>
                    {{processing ? 'Processing...' : 'Approve Request'}}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Rejection Modal -->
          <div v-if="showRejectionModal" class="modal show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5);">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header bg-danger text-white">
                  <h5 class="modal-title">
                    <i class="bx bx-x-circle me-2"></i>
                    Reject Update Request
                  </h5>
                  <button type="button" class="btn-close btn-close-white" @click="closeRejectionModal"></button>
                </div>
                <div class="modal-body">
                  <div v-if="selectedRequest">
                    <div class="row mb-3">
                      <div class="col-md-6">
                        <strong>Reference Number:</strong> {{selectedRequest.referenceNumber}}
                      </div>
                      <div class="col-md-6">
                        <strong>LR Number:</strong> {{selectedRequest.LRNumber}}
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-md-6">
                        <strong>Owner:</strong> {{selectedRequest.ownerNames}}
                      </div>
                      <div class="col-md-6">
                        <strong>Update Type:</strong> {{selectedRequest.update_type}}
                      </div>
                    </div>

                    <div class="form-group mb-3">
                      <label class="form-label">Rejection Reason *</label>
                      <textarea
                          v-model="rejectionReason"
                          class="form-control"
                          rows="4"
                          placeholder="Please provide a clear reason for rejecting this request..."
                          required
                      ></textarea>
                    </div>

                    <div class="alert alert-warning">
                      <i class="bx bx-exclamation-triangle me-2"></i>
                      <strong>Warning:</strong> The property owner will be notified about this rejection and the reason provided.
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" @click="closeRejectionModal">Cancel</button>
                  <button type="button" class="btn btn-danger" @click="confirmRejection" :disabled="processing || !rejectionReason.trim()">
                    <span v-if="processing" class="spinner-border spinner-border-sm me-2"></span>
                    <i v-else class="bx bx-x me-2"></i>
                    {{processing ? 'Processing...' : 'Reject Request'}}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Popup Modals -->
          <RequestDetailsModal
              :show="showDetailsModal"
              :request="selectedRequest"
              @close="closeDetailsModal"
              @approve="approveRequest"
              @reject="rejectRequest"
          />

          <RequestDocumentsModal
              :show="showDocumentsModal"
              :request="selectedRequest"
              @close="closeDocumentsModal"
          />

          <RequestHistoryModal
              :show="showHistoryModal"
              :request="selectedRequest"
              @close="closeHistoryModal"
          />

        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">
              ©{{new Date().getFullYear()}} County Revenue System
            </div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                Update Requests Management System
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import router from "@/router";
import {paysol, biller, execute, execute2, executeDownload, getRight, landRate} from "@/api";
import moment from 'moment';
import ToolBarValuation from "@/components/valuation/ToolBar.vue";
import RequestDetailsModal from "@/components/valuation/RequestDetailsModal.vue";
import RequestDocumentsModal from "@/components/valuation/RequestDocumentsModal.vue";
import RequestHistoryModal from "@/components/valuation/RequestHistoryModal.vue";

export default {
  name: "ValuationRequests",
  components: {ToolBarValuation, NavigationBar, RequestDetailsModal, RequestDocumentsModal, RequestHistoryModal},

  data() {
    return {
      loading: false,
      processing: false,

      // Search and filters
      searchTerm: '',
      statusFilter: '',
      updateTypeFilter: '',
      dateFrom: '',
      dateTo: '',
      perPage: 25,
      currentPage: 1,

      // Data
      updateRequests: [],

      // Statistics
      totalRequests: 0,
      pendingRequests: 0,
      approvedToday: 0,
      averageProcessingTime: 2.5,

      // Modals
      showApprovalModal: false,
      showRejectionModal: false,
      showDetailsModal: false,
      showDocumentsModal: false,
      showHistoryModal: false,
      selectedRequest: null,
      approvalNotes: '',
      rejectionReason: ''
    }
  },

  computed: {
    filteredRequests() {
      let filtered = [...this.updateRequests];

      if (this.searchTerm) {
        const term = this.searchTerm.toLowerCase();
        filtered = filtered.filter(request =>
            request.referenceNumber?.toLowerCase().includes(term) ||
            request.LRNumber?.toLowerCase().includes(term) ||
            request.ownerNames?.toLowerCase().includes(term)
        );
      }

      if (this.statusFilter) {
        filtered = filtered.filter(request => request.status === this.statusFilter);
      }

      if (this.updateTypeFilter) {
        filtered = filtered.filter(request => request.update_type?.includes(this.updateTypeFilter));
      }

      if (this.dateFrom) {
        filtered = filtered.filter(request =>
            moment(request.submitted_date).isSameOrAfter(moment(this.dateFrom))
        );
      }

      if (this.dateTo) {
        filtered = filtered.filter(request =>
            moment(request.submitted_date).isSameOrBefore(moment(this.dateTo))
        );
      }

      return filtered;
    },

    paginatedRequests() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + parseInt(this.perPage);
      return this.filteredRequests.slice(start, end);
    },

    totalPages() {
      return Math.ceil(this.filteredRequests.length / this.perPage);
    },

    visiblePages() {
      const pages = [];
      const total = this.totalPages;
      const current = this.currentPage;

      if (total <= 7) {
        for (let i = 1; i <= total; i++) {
          pages.push(i);
        }
      } else {
        if (current <= 4) {
          for (let i = 1; i <= 5; i++) {
            pages.push(i);
          }
          pages.push('...');
          pages.push(total);
        } else if (current >= total - 3) {
          pages.push(1);
          pages.push('...');
          for (let i = total - 4; i <= total; i++) {
            pages.push(i);
          }
        } else {
          pages.push(1);
          pages.push('...');
          for (let i = current - 1; i <= current + 1; i++) {
            pages.push(i);
          }
          pages.push('...');
          pages.push(total);
        }
      }

      return pages;
    }
  },

  mounted() {
    this.getUpdateRequests();
    this.menuAccess();

    // Check if there's a selected request from dashboard
    const selectedRequest = sessionStorage.getItem('selectedUpdateRequest');
    if (selectedRequest) {
      this.selectedRequest = JSON.parse(selectedRequest);
      sessionStorage.removeItem('selectedUpdateRequest');
      this.viewRequestDetails(this.selectedRequest);
    }
  },

  methods: {
    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Update Requests Management");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller)
          .then(() => {})
          .catch(() => {});
    },

    getRight(type) {
      return getRight(type);
    },

    getUpdateRequests() {
      this.loading = true;

      const data = new FormData();
      data.append("function", "getAllUpdateRequests");
      data.append("page", this.currentPage);
      data.append("perPage", this.perPage);

      execute2(data, landRate)
          .then((res) => {
            if (res.data.success) {
              const responseData = res.data.data;
              this.updateRequests = responseData.requests || [];
              this.totalRequests = responseData.total || 0;
              this.pendingRequests = responseData.pendingRequests || 0;
              this.approvedToday = responseData.approvedToday || 0;
              this.averageProcessingTime = responseData.averageProcessingTime || 2.5;
            } else {
              alert(res.data.message);
            }
          })
          .catch((e) => {
            console.error('Error loading update requests:', e);
            alert('Failed to load update requests. Please try again.');
          })
          .finally(() => {
            this.loading = false;
          });
    },

    setStatusFilter(status) {
      this.statusFilter = status;
      this.currentPage = 1;
    },

    searchRequests() {
      this.currentPage = 1;
      this.applyFilters();
    },

    applyFilters() {
      this.currentPage = 1;
      // The computed properties will handle the filtering
    },

    clearFilters() {
      this.searchTerm = '';
      this.statusFilter = '';
      this.updateTypeFilter = '';
      this.dateFrom = '';
      this.dateTo = '';
      this.currentPage = 1;
    },

    changePage(page) {
      if (page >= 1 && page <= this.totalPages && page !== '...') {
        this.currentPage = page;
      }
    },

    refreshData() {
      this.getUpdateRequests();
    },

    // Popup Modal Methods
    showRequestDetails(request) {
      this.selectedRequest = request;
      this.showDetailsModal = true;
    },

    closeDetailsModal() {
      this.showDetailsModal = false;
      this.selectedRequest = null;
    },

    showDocuments(request) {
      this.selectedRequest = request;
      this.showDocumentsModal = true;
    },

    closeDocumentsModal() {
      this.showDocumentsModal = false;
      this.selectedRequest = null;
    },

    showWorkflowHistory(request) {
      this.selectedRequest = request;
      this.showHistoryModal = true;
    },

    closeHistoryModal() {
      this.showHistoryModal = false;
      this.selectedRequest = null;
    },

    // Deprecated methods (replaced by popup modals)
    viewRequestDetails(request) {
      this.showRequestDetails(request);
    },

    viewDocuments(request) {
      this.showDocuments(request);
    },

    viewWorkflowHistory(request) {
      this.showWorkflowHistory(request);
    },

    approveRequest(request) {
      this.selectedRequest = request;
      this.approvalNotes = '';
      this.showApprovalModal = true;
    },

    rejectRequest(request) {
      this.selectedRequest = request;
      this.rejectionReason = '';
      this.showRejectionModal = true;
    },

    requestMoreInfo(request) {
      // Handle requesting more information
      this.updateRequestStatus(request, 'requires_documents', 'Additional documentation requested');
    },

    confirmApproval() {
      if (!this.selectedRequest) return;

      this.processing = true;

      const data = new FormData();
      data.append("function", "approveUpdateRequest");
      data.append("requestId", this.selectedRequest.id);
      data.append("adminUser", sessionStorage.getItem("sessionNames"));
      data.append("adminIdNo", sessionStorage.getItem("sessionIdNo"));
      data.append("notes", this.approvalNotes);

      execute2(data, landRate)
          .then((res) => {
            if (res.data.success) {
              alert('Request approved successfully!');
              this.closeApprovalModal();
              this.refreshData();
            } else {
              alert('Error approving request: ' + res.data.message);
            }
          })
          .catch((e) => {
            console.error('Error approving request:', e);
            alert('Failed to approve request. Please try again.');
          })
          .finally(() => {
            this.processing = false;
          });
    },

    confirmRejection() {
      if (!this.selectedRequest || !this.rejectionReason.trim()) return;

      this.processing = true;

      const data = new FormData();
      data.append("function", "rejectUpdateRequest");
      data.append("requestId", this.selectedRequest.id);
      data.append("adminUser", sessionStorage.getItem("sessionNames"));
      data.append("adminIdNo", sessionStorage.getItem("sessionIdNo"));
      data.append("reason", this.rejectionReason);

      execute2(data, landRate)
          .then((res) => {
            if (res.data.success) {
              alert('Request rejected successfully!');
              this.closeRejectionModal();
              this.refreshData();
            } else {
              alert('Error rejecting request: ' + res.data.message);
            }
          })
          .catch((e) => {
            console.error('Error rejecting request:', e);
            alert('Failed to reject request. Please try again.');
          })
          .finally(() => {
            this.processing = false;
          });
    },

    updateRequestStatus(request, newStatus, comments) {
      const data = new FormData();
      data.append("function", "updateRequestStatus");
      data.append("requestId", request.id);
      data.append("newStatus", newStatus);
      data.append("adminUser", sessionStorage.getItem("sessionNames"));
      data.append("adminIdNo", sessionStorage.getItem("sessionIdNo"));
      data.append("comments", comments);

      execute2(data, landRate)
          .then((res) => {
            if (res.data.success) {
              alert('Request status updated successfully!');
              this.refreshData();
            } else {
              alert('Error updating request status: ' + res.data.message);
            }
          })
          .catch((e) => {
            console.error('Error updating request status:', e);
            alert('Failed to update request status. Please try again.');
          });
    },

    closeApprovalModal() {
      this.showApprovalModal = false;
      this.selectedRequest = null;
      this.approvalNotes = '';
    },

    closeRejectionModal() {
      this.showRejectionModal = false;
      this.selectedRequest = null;
      this.rejectionReason = '';
    },

    getStatusBadge(status) {
      const badges = {
        'pending': 'bg-soft-warning text-warning',
        'under_review': 'bg-soft-info text-info',
        'approved': 'bg-soft-success text-success',
        'rejected': 'bg-soft-danger text-danger',
        'requires_documents': 'bg-soft-secondary text-secondary'
      };
      return badges[status] || 'bg-soft-secondary text-secondary';
    },

    getStatusIcon(status) {
      const icons = {
        'pending': 'bg-soft-warning text-warning',
        'under_review': 'bg-soft-info text-info',
        'approved': 'bg-soft-success text-success',
        'rejected': 'bg-soft-danger text-danger',
        'requires_documents': 'bg-soft-secondary text-secondary'
      };
      return icons[status] || 'bg-soft-secondary text-secondary';
    },

    getRequestIcon(status) {
      const icons = {
        'pending': 'bx bx-time-five',
        'under_review': 'bx bx-search-alt',
        'approved': 'bx bx-check-circle',
        'rejected': 'bx bx-x-circle',
        'requires_documents': 'bx bx-file'
      };
      return icons[status] || 'bx bx-file';
    },

    downloadReport() {
      // Prepare data for download
      const headers = ['Reference Number', 'LR Number', 'Owner Name', 'Update Type', 'Status', 'Submitted Date', 'Processed Date'];
      const rows = [headers.join(',')];

      this.filteredRequests.forEach((request) => {
        const row = [
          `"${request.referenceNumber}"`,
          `"${request.LRNumber}"`,
          `"${request.ownerNames}"`,
          `"${request.update_type}"`,
          request.status,
          moment(request.submitted_date).format('YYYY-MM-DD'),
          request.processed_date ? moment(request.processed_date).format('YYYY-MM-DD') : ''
        ];
        rows.push(row.join(','));
      });

      // Add summary
      rows.push('');
      rows.push('Summary Information');
      rows.push(`Total Requests:,${this.filteredRequests.length}`);
      rows.push(`Pending Requests:,${this.filteredRequests.filter(r => r.status === 'pending').length}`);
      rows.push(`Approved Requests:,${this.filteredRequests.filter(r => r.status === 'approved').length}`);
      rows.push(`Rejected Requests:,${this.filteredRequests.filter(r => r.status === 'rejected').length}`);

      // Create and download CSV
      const csvContent = rows.join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `update_requests_export_${moment().format('YYYY-MM-DD')}.csv`;
      link.click();
    },

    formatDate(dateString) {
      return moment(dateString).format('DD/MM/YYYY');
    },

    getTimeAgo(dateString) {
      return moment(dateString).fromNow();
    },

    gotTo(route) {
      router.push(route);
    }
  }
}
</script>

<style scoped>
.bx-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.bg-soft-primary {
  background-color: rgba(50, 149, 239, 0.1);
}

.bg-soft-success {
  background-color: rgba(52, 195, 143, 0.1);
}

.bg-soft-info {
  background-color: rgba(80, 165, 241, 0.1);
}

.bg-soft-warning {
  background-color: rgba(244, 206, 109, 0.1);
}

.bg-soft-danger {
  background-color: rgba(244, 106, 106, 0.1);
}

.bg-soft-secondary {
  background-color: rgba(133, 146, 163, 0.1);
}

.mini-stats-wid:hover {
  transform: translateY(-2px);
  transition: all 0.3s ease;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.pagination .page-link {
  cursor: pointer;
}

.dropdown-toggle::after {
  display: none;
}

.modal.show {
  display: block !important;
}

.table td {
  vertical-align: middle;
}
</style>